module.exports = __webpack_public_path__ + "components/flag/static/square/nu-c5efb00515568075996e0160746d78ff.svg";